import React from 'react';
import { UI } from '../theme';

export default function PillButton({
  children,
  onClick,
  theme,
  variant = 'primary',
  size = 'md',
  icon,
  full = false,
  testId,
  type = 'button',
  disabled = false,
}) {
  const sz = size === 'lg'
    ? { h: 56, px: 28, fs: 17 }
    : size === 'sm'
    ? { h: 36, px: 16, fs: 13 }
    : { h: 48, px: 22, fs: 15 };

  const styles = {
    primary: { bg: theme.primary, fg: theme.primaryInk, border: 'transparent', shadow: `0 8px 20px -6px ${theme.primary}80` },
    secondary: { bg: theme.surface, fg: theme.text, border: theme.cardBorder, shadow: 'none' },
    ghost: { bg: 'transparent', fg: theme.text, border: 'transparent', shadow: 'none' },
    accent: { bg: theme.accent, fg: '#2D1B4E', border: 'transparent', shadow: `0 8px 20px -6px ${theme.accent}80` },
    danger: { bg: theme.alert, fg: '#fff', border: 'transparent', shadow: `0 8px 20px -6px ${theme.alert}80` },
  };
  const v = styles[variant] || styles.primary;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
      style={{
        height: sz.h, padding: `0 ${sz.px}px`, borderRadius: 999,
        background: v.bg, color: v.fg, border: `1.5px solid ${v.border}`,
        fontFamily: UI, fontSize: sz.fs, fontWeight: 600,
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8,
        cursor: disabled ? 'not-allowed' : 'pointer',
        boxShadow: v.shadow, width: full ? '100%' : undefined,
        opacity: disabled ? 0.5 : 1,
        transition: 'transform 200ms cubic-bezier(0.4,0,0.2,1), box-shadow 200ms',
      }}
      onMouseDown={e => !disabled && (e.currentTarget.style.transform = 'scale(0.96)')}
      onMouseUp={e => (e.currentTarget.style.transform = 'scale(1)')}
      onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}
    >
      {icon}
      {children}
    </button>
  );
}
